import io from 'socket.io-client';

let oSocket = null;
let sCurrentEntryRequestID = '';

const TAB_ID =
    Date.now().toString(36) +
    '_' +
    Math.random().toString(36).substring(2);

const EVENT_CACHE = new Map();

const LEADER_KEY = 'CRM_ENTRY_NOTIFICATION_LEADER';
const LEADER_DURATION = 10000;

let iLeaderTimer = null;

function GetEventID(EventName, Payload) {
    if (Payload && Payload.Event_ID) {
        return Payload.Event_ID;
    }

    const sRequestID =
        Payload && Payload.Request_ID
            ? Payload.Request_ID
            : '';

    const sModifiedAt =
        Payload && (
            Payload.Modified_At ||
            Payload.Created_At ||
            Payload.Time
        )
            ? (
                Payload.Modified_At ||
                Payload.Created_At ||
                Payload.Time
            )
            : '';

    const sAction =
        Payload && (
            Payload.Modified_Short_Code ||
            Payload.Action ||
            Payload.Status
        )
            ? (
                Payload.Modified_Short_Code ||
                Payload.Action ||
                Payload.Status
            )
            : '';

    return [
        EventName,
        sRequestID,
        sModifiedAt,
        sAction
    ].join('|');
}

function IsDuplicatedEvent(EventName, Payload) {
    const sEventID = GetEventID(EventName, Payload);
    const iNow = Date.now();

    if (EVENT_CACHE.has(sEventID)) {
        return true;
    }

    EVENT_CACHE.set(sEventID, iNow);

    if (EVENT_CACHE.size > 500) {
        EVENT_CACHE.forEach((Value, Key) => {
            if (iNow - Value > 5 * 60 * 1000) {
                EVENT_CACHE.delete(Key);
            }
        });
    }

    return false;
}

function ReadLeader() {
    try {
        const sData = localStorage.getItem(LEADER_KEY);

        if (!sData) {
            return null;
        }

        return JSON.parse(sData);
    } catch (err) {
        return null;
    }
}

function TryBecomeNotificationLeader() {
    const iNow = Date.now();
    const oLeader = ReadLeader();

    if (
        !oLeader ||
        !oLeader.Tab_ID ||
        oLeader.Expired_At < iNow ||
        oLeader.Tab_ID === TAB_ID
    ) {
        const oNewLeader = {
            Tab_ID: TAB_ID,
            Expired_At: iNow + LEADER_DURATION
        };

        localStorage.setItem(
            LEADER_KEY,
            JSON.stringify(oNewLeader)
        );

        const oCheck = ReadLeader();

        return !!(
            oCheck &&
            oCheck.Tab_ID === TAB_ID
        );
    }

    return false;
}

function StartNotificationLeader() {
    TryBecomeNotificationLeader();

    if (iLeaderTimer) {
        clearInterval(iLeaderTimer);
    }

    iLeaderTimer = setInterval(() => {
        TryBecomeNotificationLeader();
    }, 4000);
}

function StopNotificationLeader() {
    if (iLeaderTimer) {
        clearInterval(iLeaderTimer);
        iLeaderTimer = null;
    }

    const oLeader = ReadLeader();

    if (
        oLeader &&
        oLeader.Tab_ID === TAB_ID
    ) {
        localStorage.removeItem(LEADER_KEY);
    }
}

function IsNotificationLeader() {
    const oLeader = ReadLeader();

    if (
        oLeader &&
        oLeader.Tab_ID === TAB_ID &&
        oLeader.Expired_At >= Date.now()
    ) {
        return true;
    }

    return TryBecomeNotificationLeader();
}

function Connect(Options) {
    Disconnect();

    const {
        Domain,
        Token,
        Username,
        OnConnected,
        OnDisconnected,
        OnEntryNew,
        OnEntryUpdated,
        OnEntryLog,
        OnEntryPresence,
        OnSummaryUpdated
    } = Options;

    StartNotificationLeader();

    oSocket = io(Domain, {
        transports: ['websocket', 'polling'],
        path: '/crm/socket.io',
        auth: {
            Token,
            Username
        },

        query: {
            Token,
            Username
        },

        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000
    });

    oSocket.on('connect', () => {
        if (
            sCurrentEntryRequestID &&
            oSocket
        ) {
            oSocket.emit('crm:entry:join', {
                Request_ID: sCurrentEntryRequestID
            });
        }

        if (typeof OnConnected === 'function') {
            OnConnected();
        }
    });

    oSocket.on('disconnect', Reason => {
        if (typeof OnDisconnected === 'function') {
            OnDisconnected(Reason);
        }
    });

    oSocket.on('crm:entry:new', Payload => {
        if (
            IsDuplicatedEvent(
                'crm:entry:new',
                Payload
            )
        ) {
            return;
        }

        if (typeof OnEntryNew === 'function') {
            OnEntryNew(Payload);
        }
    });

    oSocket.on(
        'crm:entry:updated',
        Payload => {
            if (
                IsDuplicatedEvent(
                    'crm:entry:updated',
                    Payload
                )
            ) {
                return;
            }

            const Status = String(
                Payload &&
                    Payload.Entry &&
                    Payload.Entry.Status
                    ? Payload.Entry.Status
                    : ''
            )
                .trim()
                .toUpperCase();

            const CanEdit = [
                'IN_REVIEW',
                'RE_REVIEW'
            ].includes(
                Status
            );

            const UpdatedPayload = {
                ...(Payload || {}),

                Permissions: {
                    ...(
                        Payload &&
                            Payload.Permissions
                            ? Payload.Permissions
                            : {}
                    ),

                    Can_Edit:
                        CanEdit,

                    Can_Verify_Image:
                        CanEdit
                }
            };

            if (
                typeof OnEntryUpdated ===
                'function'
            ) {
                OnEntryUpdated(
                    UpdatedPayload
                );
            }
        }
    );
    // oSocket.on('crm:entry:updated', Payload => {
    //     if (
    //         IsDuplicatedEvent(
    //             'crm:entry:updated',
    //             Payload
    //         )
    //     ) {
    //         return;
    //     }

    //     if (typeof OnEntryUpdated === 'function') {
    //         OnEntryUpdated(Payload);
    //     }
    // });

    oSocket.on('crm:entry:log', Payload => {
        if (
            IsDuplicatedEvent(
                'crm:entry:log',
                Payload
            )
        ) {
            return;
        }

        if (typeof OnEntryLog === 'function') {
            OnEntryLog(Payload);
        }
    });

    oSocket.on('crm:entry:presence', Payload => {
        if (typeof OnEntryPresence === 'function') {
            OnEntryPresence(Payload);
        }
    });

    oSocket.on('crm:entry:summary', Payload => {
        if (
            IsDuplicatedEvent(
                'crm:entry:summary',
                Payload
            )
        ) {
            return;
        }

        if (typeof OnSummaryUpdated === 'function') {
            OnSummaryUpdated(Payload);
        }
    });

    return oSocket;
}

function JoinEntry(Request_ID) {
    if (!Request_ID) {
        return;
    }

    if (
        sCurrentEntryRequestID &&
        sCurrentEntryRequestID !== Request_ID
    ) {
        LeaveEntry(sCurrentEntryRequestID);
    }

    sCurrentEntryRequestID = Request_ID;

    if (
        oSocket &&
        oSocket.connected
    ) {
        oSocket.emit('crm:entry:join', {
            Request_ID
        });
    }
}

function LeaveEntry(Request_ID) {
    const sRequestID =
        Request_ID ||
        sCurrentEntryRequestID;

    if (
        sRequestID &&
        oSocket &&
        oSocket.connected
    ) {
        oSocket.emit('crm:entry:leave', {
            Request_ID: sRequestID
        });
    }

    if (
        !Request_ID ||
        Request_ID === sCurrentEntryRequestID
    ) {
        sCurrentEntryRequestID = '';
    }
}

function Disconnect() {
    if (oSocket) {
        if (sCurrentEntryRequestID) {
            LeaveEntry(sCurrentEntryRequestID);
        }

        oSocket.removeAllListeners();
        oSocket.disconnect();
        oSocket = null;
    }

    StopNotificationLeader();
}

export default {
    Connect,
    Disconnect,
    JoinEntry,
    LeaveEntry,
    IsNotificationLeader
};